import { Link } from 'react-router-dom';

export function MagicLinkSent() {
  return (
    <div className="min-h-screen bg-cream flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <div className="mb-6">
          <div className="w-16 h-16 bg-teal/10 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-teal" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
          </div>
          <h1 className="text-2xl font-serif text-ink mb-2">Link trimis!</h1>
        </div>

        <div className="space-y-4 text-muted">
          <p>Am trimis un email cu link-ul de acces la adresa furnizată.</p>
          <p className="text-sm">Link-ul este valabil 15 minute.</p>
          
          <div className="mt-6 p-4 bg-warm rounded-lg text-sm">
            <p className="font-medium text-ink mb-2">💡 Pentru testare:</p>
            <p>Verificați consola backend-ului pentru a vedea email-ul mock.</p>
          </div>
        </div>

        <div className="mt-8">
          <Link to="/auth/login" className="text-teal hover:underline">
            ← Înapoi la autentificare
          </Link>
        </div>
      </div>
    </div>
  );
}
